import {
  Dropdown,
  IconButton,
  ListItemDecorator,
  Menu,
  MenuButton,
  MenuItem,
  Avatar,
} from "@mui/joy";
import { LogOut, User2, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { env } from "../../config";
import { useAuth } from "../../hooks";

const LOGOUT_URL = `${env.API_ENDPOINT}/v1/auth/external/cognito/logout`;

function getUserInitials(user: any): string {
  const first = String(user?.FirstName || "").trim();
  const last = String(user?.LastName || "").trim();
  const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  if (initials) return initials;

  const email = String(user?.Email || "").trim();
  if (email) return email.charAt(0).toUpperCase();

  return "?";
}

export default function UserQuickNavigation() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const initials = getUserInitials(user);
  const fullName = [user?.FirstName, user?.LastName].filter(Boolean).join(" ").trim();

  const handleOnLogout = () => {
    window.location.href = LOGOUT_URL;
  };

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: IconButton }}
        slotProps={{
          root: {
            variant: "plain",
            color: "neutral",
            sx: {
              borderRadius: "sm",
              display: "flex",
              gap: 0.5,
              alignItems: "center",
              px: 0.5,
              py: 0.5,
            },
          },
        }}
        title={fullName || "Profile"}
      >
        <Avatar
          size="sm"
          variant="soft"
          color="primary"
          sx={{
            width: 28,
            height: 28,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.02em",
          }}
        >
          {initials}
        </Avatar>
        <ChevronDown size={16} />
      </MenuButton>
      <Menu placement="bottom-end">
        <MenuItem onClick={() => navigate("/settings")}>
          <ListItemDecorator>
            <User2 size={16} />
          </ListItemDecorator>{" "}
          Settings
        </MenuItem>
        <MenuItem onClick={handleOnLogout}>
          <ListItemDecorator>
            <LogOut size={16} />
          </ListItemDecorator>{" "}
          Logout
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}
